export const NotFoundPage = () => <div><h2>Not Found</h2><p>Page not found.</p></div>;

export default NotFoundPage;
